import {
	ApplicationConfig,
	inject,
	provideAppInitializer,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
	provideRouter,
	withInMemoryScrolling,
	withRouterConfig,
} from '@angular/router';
import {
	provideServiceWorker,
	SwRegistrationOptions,
} from '@angular/service-worker';
import { provideFuse } from '@fuse';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { appConfig as _appConfig } from 'app/core/config/app.config';
import { provideClaimMosaic } from './core/provider/cm.provider';
import { provideAuth0 } from '@auth0/auth0-angular';
import { PwaAccessService } from './core/pwa/pwa-access.service';
import { PwaUpdateService } from './core/pwa/pwa-update.service';
import { environment } from 'environments/environment';

export const appConfig: ApplicationConfig = {
	providers: [
		provideAnimations(),
		provideRouter(
			appRoutes,
			withInMemoryScrolling({
				scrollPositionRestoration: 'enabled',
				anchorScrolling: 'enabled',
			}),
			withRouterConfig({
				onSameUrlNavigation: 'reload',
				paramsInheritanceStrategy: 'always',
			})
		),

		// Fuse
		provideAuth(),
		provideIcons(),
		provideFuse({
			fuse: _appConfig,
		}),

		// Claim Mosaic
		provideClaimMosaic(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideServiceWorker(environment.pwa.swScript),
		{
			provide: SwRegistrationOptions,
			useFactory: (
				pwaAccessService: PwaAccessService
			): SwRegistrationOptions => ({
				enabled: environment.pwa.enabled,
				registrationStrategy: () =>
					pwaAccessService.serviceWorkerRegistrationTrigger$,
			}),
			deps: [PwaAccessService],
		},
		provideAppInitializer(() => {
			const pwaAccessService = inject(PwaAccessService);
			pwaAccessService.initialize();
		}),
		provideAppInitializer(() => {
			const pwaUpdateService = inject(PwaUpdateService);
			pwaUpdateService.initialize();
		}),

		// Auth0
		provideAuth0({
			...environment.auth0,
			cacheLocation: 'localstorage',
			authorizationParams: {
				...environment.auth0.authorizationParams,
				redirect_uri: window.location.origin,
			},
			httpInterceptor: {
				allowedList: [
					{
						uri: `${environment.apiUrl}/*`,
						tokenOptions: {
							authorizationParams: {
								scope: 'openid profile email',
							},
						},
					},
				],
			},
		}),
	],
};
